import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _createClass from 'babel-runtime/helpers/createClass';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n     \tquery query {\n     \t     \n     \t       productByHandle(handle: "', '") {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\thandle\t\n     \t        title\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\tproductType\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\toptions {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\tvalues\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tvariants(first: 100) {\n\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\t\t\t\tcompareAtPrice\n\t\t\t\t\t\t\t\t\t\tavailableForSale\n\t\t\t\t\t\t\t\t\t\tselectedOptions {\n\t\t\t\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\timage {\n\t\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\t\tthumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\t\tproductImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\timages(first: 2) {\n\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\tthumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\tproductImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t'], ['\n     \tquery query {\n     \t     \n     \t       productByHandle(handle: "', '") {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\thandle\t\n     \t        title\n\t\t\t\t\t\t\tdescription\n\t\t\t\t\t\t\tproductType\n\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\toptions {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\tvalues\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tvariants(first: 100) {\n\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\t\t\tprice\n\t\t\t\t\t\t\t\t\t\tcompareAtPrice\n\t\t\t\t\t\t\t\t\t\tavailableForSale\n\t\t\t\t\t\t\t\t\t\tselectedOptions {\n\t\t\t\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\t\t\t\tvalue\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\timage {\n\t\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\t\tthumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\t\tproductImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\timages(first: 2) {\n\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\tthumbnailImg:transformedSrc(maxWidth: 100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t\t\t\t\tproductImg:transformedSrc(maxWidth: 800, maxHeight: 960, crop:CENTER)\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t']);

import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import Step from '../step/step.js';
import './kit.css';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { htmlDecode, slugify } from '../helpers.js';
import { getInitialSelectedOptions, productVariantFromBase64String, addVariantsToCart, addCartNote } from '../utilities.js';

var _ref = React.createElement(
	'span',
	{ className: 'title' },
	'configured price:'
);

var _ref3 = React.createElement(
	'div',
	{ className: 'no-info' },
	'Product info not found'
);

var _ref4 = React.createElement(
	'div',
	{ className: 'loading' },
	'Loading...',
	React.createElement(
		'div',
		{ className: 'loader' },
		React.createElement('span', { className: 'inner1' }),
		React.createElement('span', { className: 'inner2' }),
		React.createElement('span', { className: 'inner3' })
	)
);

var _ref5 = React.createElement(
	'div',
	{ className: 'kit-builder-info' },
	React.createElement(
		'p',
		null,
		'Do you have any questions about this product? Feel free to reach us at ',
		React.createElement(
			'a',
			{ href: 'mailto:support@walterklassen.com', target: '_blank' },
			'support@walterklassen.com'
		),
		' and we\'d be happy to help.'
	)
);

var _ref6 = React.createElement(
	'h1',
	null,
	'No Product Available'
);

var Kit = function (_Component) {
	_inherits(Kit, _Component);

	_createClass(Kit, [{
		key: 'createProductQuery',
		value: function createProductQuery(handle) {
			return gql(_templateObject, handle);
		}
	}]);

	function Kit() {
		_classCallCheck(this, Kit);

		var _this = _possibleConstructorReturn(this, (Kit.__proto__ || Object.getPrototypeOf(Kit)).call(this));

		_this.state = {
			variants: [],
			line_items: [],
			sub_products: [],
			total: 0,
			add_to_cart_classes: "button",
			add_to_cart_text: "Add To Cart +"
		};

		_this.loadedMainProduct = _this.loadedMainProduct.bind(_this);
		_this.parseProductDescription = _this.parseProductDescription.bind(_this);
		_this.loadedSubProduct = _this.loadedSubProduct.bind(_this);
		_this.setVariantCheckbox = _this.setVariantCheckbox.bind(_this);
		_this.setVariantRadio = _this.setVariantRadio.bind(_this);
		_this.toggleBoolean = _this.toggleBoolean.bind(_this);
		_this.calcTotal = _this.calcTotal.bind(_this);
		_this.setPreselections = _this.setPreselections.bind(_this);
		_this.addLineItem = _this.addLineItem.bind(_this);
		_this.updateQuantity = _this.updateQuantity.bind(_this);
		_this.headerScroll = _this.headerScroll.bind(_this);
		_this.transformVariantsForCart = _this.transformVariantsForCart.bind(_this);
		_this.transformLineItemsForCart = _this.transformLineItemsForCart.bind(_this);
		return _this;
	}

	_createClass(Kit, [{
		key: 'transformVariantsForCart',
		value: function transformVariantsForCart() {
			var allVariants = this.state.variants.map(function (variant, index) {
				return {
					quantity: parseInt(variant.quantity) || 1,
					id: productVariantFromBase64String(variant.id)
				};
			});
			console.log("ENCODED ALL VARIANTS", allVariants);
			addVariantsToCart(allVariants);
			this.transformLineItemsForCart();
			this.setState({ add_to_cart_classes: 'button disabled' });
			this.setState({ add_to_cart_text: 'Added to Cart :)' });
		}
	}, {
		key: 'transformLineItemsForCart',
		value: function transformLineItemsForCart() {
			var allLineItems = this.state.line_items.reduce(function (object, line_item) {
				object[line_item.name] = line_item.value;
				return object;
			}, {});
			console.log("ALL LINE ITEMS", JSON.stringify(allLineItems));
			addCartNote(JSON.stringify(allLineItems));
		}
	}, {
		key: 'headerScroll',
		value: function headerScroll() {
			var windowHeight = window.scrollY;
			var kitHeader = document.getElementById('kit-builder-body');
			var price = document.getElementById('price');
			if (windowHeight > kitHeader.offsetTop) {
				price.classList.add('scrolled');
			} else {
				price.classList.remove('scrolled');
			}
		}
	}, {
		key: 'updateQuantity',
		value: function updateQuantity(quantity, value) {
			var _this2 = this;

			console.log('update q', quantity, value);
			var this_variant = this.state.variants.find(function (variant) {
				return variant.title === value;
			});

			this_variant.quantity = quantity;

			var filtered_variants = this.state.variants.filter(function (variant) {
				return variant.title !== value;
			});

			this.setState({ variants: [].concat(_toConsumableArray(filtered_variants), [this_variant]) }, function () {
				_this2.calcTotal();
			});
		}
	}, {
		key: 'calcTotal',
		value: function calcTotal() {
			var total = this.state.variants.reduce(function (total, variant) {
				var quantity = variant.quantity || 1;
				return total + parseInt(variant.price) * quantity;
			}, 0);
			this.setState({ total: total });
		}
	}, {
		key: 'addLineItem',
		value: function addLineItem(value, label) {
			console.log("ADDING LINE ITEM", value, label);
			var new_line_item = {};
			new_line_item.name = label;
			new_line_item.value = value;
			var filtered_line_items = this.state.line_items.filter(function (line_item) {
				return line_item.name !== label;
			});
			this.setState({ line_items: [].concat(_toConsumableArray(filtered_line_items), [new_line_item]) });
		}

		//value = option value
		//label = option name
		//shopify_title = product title

	}, {
		key: 'setVariantRadio',
		value: function setVariantRadio(value, label, shopify_title) {
			var _this3 = this;

			//Find which product we're dealing with
			var product = this.state.sub_products.filter(function (product) {
				return product.title === shopify_title;
			})[0];

			//find the selection we're dealing with
			var selection = product.wkSelectedOptions.find(function (option) {
				return option.name.trim() === label.trim();
			});

			// Set the new value for the selection
			selection.value = value;

			// Grab all the selections that aren't the one we're dealing with
			var new_wkSelectedOptions = product.wkSelectedOptions.filter(function (option) {
				return option.name.trim() !== label;
			});

			// Add the changed selection to all the other ones
			product.wkSelectedOptions = [].concat(_toConsumableArray(new_wkSelectedOptions), [selection]);

			// Grab all the sub products that are the product we're dealing with
			var new_sub_products = this.state.sub_products.filter(function (sub_product) {
				return sub_product.title !== shopify_title;
			});

			// Add all the sub products with the changed on back to state, then update the walter klassen selected options
			this.setState({ sub_products: [].concat(_toConsumableArray(new_sub_products), [product]) }, function () {
				var thisSelectedOptions = {};
				product.wkSelectedOptions.forEach(function (option) {
					thisSelectedOptions[option.name.trim()] = option.value.trim();
				});

				// Find the variant that corresponds to the selected options 
				var something = product.variants.edges.find(function (variant) {
					return variant.node.selectedOptions.every(function (selectedOption) {
						return htmlDecode(thisSelectedOptions[selectedOption.name]) === selectedOption.value;
					});
				}).node;

				// Add the product handle so we can keep track of which product it's associated with
				something.product_handle = product.handle;

				// Grab all the variants that aren't the variant we're dealing with
				var filtered_variants = _this3.state.variants.filter(function (variant) {
					return variant.product_handle !== product.handle;
				});

				//Set the new state will all the variants and also the changed/new variant
				_this3.setState({ variants: [].concat(_toConsumableArray(filtered_variants), [something]) }, function () {
					_this3.calcTotal();
				});
			});
		}

		//checked --> boolean
		//value = option value
		//label = option name
		//shopify_title = product title

	}, {
		key: 'setVariantCheckbox',
		value: function setVariantCheckbox(checked, value, label, shopify_title, quantity) {
			var _this4 = this;

			console.log("ADD VARIANT CHECK", quantity);
			//Find the selected product in the sub products
			// TODO (maybe make a function findSubProductByTitle())
			var product = this.state.sub_products.filter(function (product) {
				return product.title === shopify_title;
			})[0];

			if (checked) {
				console.log("THISI IS CHECKED ==> REMOVE");
				//REMOVE THE SELECTION
				// Grab all the selections that aren't the one we're dealing with
				var new_wkSelectedOptions = product.wkSelectedOptions.filter(function (option) {
					return htmlDecode(option.value.trim()) !== value;
				});

				// Add the changed selection to all the other ones
				product.wkSelectedOptions = [].concat(_toConsumableArray(new_wkSelectedOptions));
			} else {
				//NEW SELECTION
				// Create a new selection to add to the existing ones
				console.log("THISI NOT *** IS CHECKED ==> ADD");
				var selection = {};
				selection.name = label;
				selection.value = value;
				product.wkSelectedOptions = [].concat(_toConsumableArray(product.wkSelectedOptions), [selection]);
			}

			// Grab all the sub products that aren't the product we're dealing with
			var new_sub_products = this.state.sub_products.filter(function (sub_product) {
				return sub_product.title !== shopify_title;
			});
			// Add all the sub products with the changed one back to state, then update the walter klassen selected options
			this.setState({ sub_products: [].concat(_toConsumableArray(new_sub_products), [product]) }, function () {
				var thisSelectedOptions = {};
				product.wkSelectedOptions.forEach(function (option) {
					thisSelectedOptions[option.name.trim()] = option.value.trim();
				});

				var unselectedOption = {};
				unselectedOption[label.trim()] = value.trim();

				// Find the variant that corresponds to the selected options 
				// TODO (maybe make this into a function findSelectedVariant())
				var something = void 0;
				var something_removable = void 0;
				if (!checked) {
					something = product.variants.edges.find(function (variant) {
						return variant.node.selectedOptions.every(function (selectedOption) {
							console.log("SELECTION OPTION VALUE", selectedOption.value);
							return htmlDecode(thisSelectedOptions[selectedOption.name]) === selectedOption.value;
						});
					});

					if (something) {
						console.log('SOMETHING', something.node);
						something = something.node;
						// Add the product handle so we can keep track of which product it's associated with
						something.product_handle = product.handle;
						// console.log('is quantity updated', quantity)
						something.quantity = quantity;
					}
				} else {
					something_removable = product.variants.edges.find(function (variant) {
						return variant.node.selectedOptions.every(function (selectedOption) {
							return htmlDecode(unselectedOption[label]) === selectedOption.value;
						});
					}).node;
				}

				if (!checked) {
					_this4.setState({ variants: [].concat(_toConsumableArray(_this4.state.variants), [something]) }, function () {
						_this4.calcTotal();
					});
				} else {
					var filtered_variants = _this4.state.variants.filter(function (variant) {
						return variant.id != something_removable.id;
					});
					_this4.setState({ variants: filtered_variants }, function () {
						_this4.calcTotal();
					});
				}
			});
		}
	}, {
		key: 'setPreselections',
		value: function setPreselections() {
			console.log('setting the preselections');
		}
	}, {
		key: 'loadedMainProduct',
		value: function loadedMainProduct(product) {
			this.setState({ product: product });
		}
	}, {
		key: 'loadedSubProduct',
		value: function loadedSubProduct(data, selectedOptions, selection_types) {
			var _this5 = this;

			var sub_product = data.productByHandle;
			sub_product.wkSelectedOptions = selectedOptions;

			// Find out if this sub product has selections for variants with radio buttons or checkboxes
			var has_radio = selection_types.find(function (item) {
				return item.type === "variants" && item.select_by === 'radio';
			});
			var has_checkbox = selection_types.find(function (item) {
				return item.type === "variants" && item.select_by === 'checkbox';
			});

			this.setState(function (prevState) {
				return {
					sub_products: [].concat(_toConsumableArray(prevState.sub_products), [sub_product])
				};
			}, function () {

				// INITIAL PRODUCT/PRICE SETUP
				// Once we set the sub product to state set the pre-selected options
				// has_radio and has_checkbox will either be an object or undefined (truthy/falsy)
				if (has_radio) {
					selectedOptions.forEach(function (option) {
						_this5.setVariantRadio(option.value, option.name, sub_product.title);
					});
				}
				if (has_checkbox) {
					selectedOptions.forEach(function (option) {
						_this5.setVariantCheckbox(false, option.value, option.name, sub_product.title);
					});
				}
			});
		}
	}, {
		key: 'toggleBoolean',
		value: function toggleBoolean(bool) {
			return !bool;
		}
	}, {
		key: 'parseProductDescription',
		value: function parseProductDescription(description) {
			var kit = description.split('[[KITBUILDER]]')[1];
			var kit_object = void 0;
			if (kit) {
				kit_object = JSON.parse(kit);
				// console.log('kit object',kit_object)
			}
			return kit_object;
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			console.log('mounted');
			this.loadedMainProduct(this.props.product);
			window.addEventListener('scroll', this.headerScroll);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			var _state = this.state,
			    total = _state.total,
			    add_to_cart_text = _state.add_to_cart_text,
			    add_to_cart_classes = _state.add_to_cart_classes;
			var product = this.props.product;

			var product_description = this.parseProductDescription(product.description);
			var products = product_description ? product_description.products : null;
			return React.createElement(
				'div',
				{ className: 'kit-builder-container' },
				products ? React.createElement(
					'div',
					null,
					React.createElement(
						'div',
						{ id: 'kit-header', className: 'kit-header' },
						React.createElement(
							'div',
							{ className: 'kit-header-title' },
							React.createElement(
								'h1',
								null,
								product.title
							),
							React.createElement(
								'p',
								null,
								product.productType
							)
						),
						React.createElement(
							'div',
							{ className: 'kit-header-price' },
							React.createElement(
								'p',
								{ id: 'money-container', className: 'money-container' },
								_ref,
								React.createElement(
									'span',
									{ id: 'price', className: 'price-container' },
									React.createElement(
										'span',
										{ className: 'price' },
										'$',
										total
									),
									React.createElement(
										'span',
										{ className: 'currency' },
										product.priceRange.minVariantPrice.currencyCode
									)
								)
							)
						)
					),
					React.createElement(
						'div',
						{ id: 'kit-builder-body', className: 'kit-builder' },
						React.createElement(
							'h2',
							null,
							product.title
						),
						React.createElement(
							'form',
							{ onSubmit: this.handleSubmit },
							products.map(function (product, index) {
								var wkSelectedOptions = product.selectedOptions;
								var selection_types = product.selections;
								return React.createElement(
									Query,
									{
										key: 'subproduct-' + index,
										query: _this6.createProductQuery(product.handle.trim()),
										onCompleted: function onCompleted(data) {
											_this6.loadedSubProduct(data, wkSelectedOptions, selection_types);
										} },
									function (_ref2) {
										var loading = _ref2.loading,
										    err = _ref2.err,
										    data = _ref2.data;

										if (!loading) {
											// const shopify_product = data.productByHandle
											var shopify_product = _this6.state.sub_products.filter(function (sub_product) {
												return sub_product.handle === product.handle.trim();
											})[0];

											if (shopify_product) {
												var info = product.info;
												var sub_note = product.sub_note;
												var shopify_image = shopify_product.images.edges[0] ? shopify_product.images.edges[0].node.productImg : 'placeholder.png';
												return React.createElement(Step, {
													index: index,
													title: shopify_product.title,
													myImage: shopify_image,
													info: info,
													sub_note: sub_note,
													selections: product.selections,
													selection_note: product.wkSelectionNote,
													wkSelectedOptions: shopify_product.wkSelectedOptions,
													line_items: _this6.state.line_items,
													shopify_product: shopify_product,
													setVariantCheckbox: _this6.setVariantCheckbox,
													setVariantRadio: _this6.setVariantRadio,
													addLineItem: _this6.addLineItem,
													updateQuantity: _this6.updateQuantity });
											} else {
												return _ref3;
											}
										} else {
											return _ref4;
										}
									}
								);
							})
						)
					),
					React.createElement(
						'div',
						{ className: 'kit-builder-footer' },
						React.createElement(
							'div',
							{ className: 'kit-builder-quantity' },
							React.createElement(
								'p',
								{ className: 'money-container' },
								React.createElement(
									'span',
									{ className: 'price' },
									'$',
									total
								),
								React.createElement(
									'span',
									{ className: 'currency' },
									product.priceRange.minVariantPrice.currencyCode
								)
							),
							React.createElement(
								'button',
								{ onClick: this.transformVariantsForCart, className: add_to_cart_classes },
								add_to_cart_text
							)
						),
						_ref5
					)
				) : _ref6
			);
		}
	}]);

	return Kit;
}(Component);

export default Kit;